import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Mentors from './pages/Mentors';
import Register from './pages/Register';

const Routes = () => {
  return (
    <BrowserRouter>
      <Route path="/" exact component={Landing} />
      <Route path="/mentors" component={Mentors} />
      <Route path="/register" component={Register} />
    </BrowserRouter>
  )
}

export default Routes;